// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQSettingConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React, { PureComponent } from 'react';
import uiState from 'logic/Izenda.UiState.js';
import CommonMessages from 'share/messages/Izenda.CommonMessages';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import DropDown from 'share/components/controls/Izenda.DropDown';
import Button from 'share/components/controls/Izenda.Button';
import classnames from 'classnames';
import { isNil, isEmpty, isEqual, has, includes, cloneDeep, get, find, remove, defaultTo, invokeArgs,filter } from 'lodash/fp';
import { action, computed, observable,observe } from 'mobx'

const NLQ_NOTIFICATION_MESSAGE_KEY = {
  COMPLETED: 'Completed',
  PROGRESS: 'Inprogress',
  ERROR: 'Error'
};
const RESET_NLQ_NOTIFICATION_MESSAGE_KEY = {
  RESETSUCCESS: 'ResetSuccess',
  RESETERROR: 'ResetError'
};
const MESSAGE_TYPE = CommonMessages.MESSAGE_TYPE;
const NLQCONFIGURATION_STATUS_MESSAGE = CommonMessages.NLQCONFIGURATION_STATUS_MESSAGE;
const clazzName = classnames('customeHeight');
const sucessConfigMessage = 'NLQ Module Configured';
const infoConfigMessage = 'NLQ configuration is in progress';
const resetConfirmMessage='Are you sure you want to reset NLQ configuration ?';
const completed = 'Completed';
const inProgress = 'InProgress';
const initialize = 'Initialize';
const deleted = 'Deleted';
const error = 'Error';
const localStoarageKey = 'schemaKeyInfo';
const errorMessage = 'We are not able to connect to ML service. Please contact administrator for this.';
const activeNLQDisableMsg ='Active NLQ schema is disabled';
const connectionDisableMsg ='You cannot configure this because NLQ schema is disabled';
class NLQSettingConfiguration extends PureComponent {
  constructor(props) {
    super(props);
    this.connectionList = [];
    this.selectedConnection = {
      dbName: '',
      connectionId: ''
    };
    this.isProressBar = false;
    this.message = '';
    this.schemaStatus = null;
    this.activeNLQInfo = null;
    this.state = this.initializeDefaultValues(this.connectionList);
  }

  componentDidMount() {
    this.loadConnectionList(this);
    this.disposeObserveTenantID = observe(uiState, 'tenantId', () => {
    if (uiState.silentUpdate) return;
    this.loadConnectionList(this);
    });
  }

  componentDidUpdate() {
    let self = this;
    if (this.state.schemaStatus && this.state.schemaStatus.toLowerCase() == inProgress.toLowerCase()) {
      if (this.state.schemaStatus) {
      var interval = setInterval(() => {
        self.props.store.getConfigureNLQStatus().then(res => {
          if (res.status === completed) {
            let selectedConnection = {};
            selectedConnection.dbName = res.activeNLQ.dBName;
            selectedConnection.connectionId = res.activeNLQ.connectionId;
            let updateStateValue = self.updateState(
              self.state.connectionList,
              res.schemaKey,
              self.getConfigureIsDisable(res.status),
              selectedConnection,
              self.getmessage(res.status),
              self.getIsProgressBar(res.status),
              res.status
            );
            self.setState(updateStateValue);
            self.activeNLQInfo = updateStateValue;
            var activeNlqInfo =self.state.connectionList.filter(item => item.id==res.activeNLQ.connectionId);
            if(!activeNlqInfo[0].visible){
                self.setState({message:activeNLQDisableMsg,isProressBar:false,isConfigureDisable:true});
              }
            clearInterval(interval);
          }
          else if (res.status == initialize) {
            let selectedConnection = {};
            selectedConnection.dbName = self.selectedConnection.dBName;
            selectedConnection.connectionId = self.selectedConnection.connectionId;
            let updateStateValue = self.updateState(
              self.state.connectionList,
              self.selectedConnection.connectionId,
              self.getConfigureIsDisable(initialize),
              selectedConnection,
              self.getmessage(initialize),
              self.getIsProgressBar(initialize),
              res.status
            );
            self.setState(updateStateValue);
            self.activeNLQInfo = updateStateValue;
            clearInterval(interval);
          }
          else if (res.status == error) {
            self.setState({
            isProressBar:false,
            isConfigureDisable:false,
            schemaStatus:error,
            message:res.message
             });
            self.activeNLQInfo = null;
            clearInterval(interval);
            }
        }).catch(function(error) {
          console.log(error);
          self.setState({
            isProressBar:false,
            isConfigureDisable:false,
            schemaStatus:'Error',
            message:errorMessage
          });
          self.activeNLQInfo = null;
          clearInterval(interval);
        });
      }, 13000);
    }
  }
  }
  loadConnectionList = async self => {
    try {
      // let schemaKey = null;
      let configStatusInfo = null;
      // if (localStorage.getItem(localStoarageKey) != null) {
      //   const schemaKeyInfo = JSON.parse(localStorage.getItem(localStoarageKey));
      //   schemaKey = schemaKeyInfo.schemaKey;
      // }
      const connectionList = await self.props.store.getAllConnectionString();
      const mssqlConnectionList = connectionList.filter(item => item.serverTypeName=="MSSQL" || item.serverTypeName=="PGSQL");
      //if (schemaKey != null)
      configStatusInfo = await self.props.store.getConfigureNLQStatus();
      if (configStatusInfo.schemaKey == null) {
        let updateStateValue = self.updateState(
          mssqlConnectionList,
          configStatusInfo.schemaKey,
          true,
          self.selectedConnection,
          self.message,
          self.isProressBar,
          self.schemaStatus
        );

        self.setState(updateStateValue);
      } else {
        let updateStateValue = self.updateState(
          mssqlConnectionList,
          configStatusInfo.schemaKey,
          self.getConfigureIsDisable(configStatusInfo.status),
          self.getSelectedConnection(mssqlConnectionList, configStatusInfo.status, configStatusInfo.schemaKey),
          self.getmessage(configStatusInfo.status),
          self.getIsProgressBar(configStatusInfo.status),
          configStatusInfo.status
        );
        self.activeNLQInfo = updateStateValue;
        
        self.setState(updateStateValue);
        var activeNlqInfo =mssqlConnectionList.filter(item => item.id==configStatusInfo.schemaKey);
        if(!activeNlqInfo[0].visible){
        self.setState({message:activeNLQDisableMsg,isProressBar:false,isConfigureDisable:true});
      }
      }
    } catch (error) {
      console.log(error);
      self.setState({
        isProressBar: false,
        isConfigureDisable: false,
        schemaStatus: 'Error',
        message: errorMessage
      });
      self.activeNLQInfo = null;
    }
  };

  getSelectedConnection(connectionList, status, schemaKey) {
    let selectedConnection = {};
    const selectedConnectionInfo = connectionList.filter(function(key) {
      return key.id.toLowerCase() === schemaKey.toLowerCase();
    });
    if (status && status.toLowerCase() === inProgress.toLowerCase()) {
      selectedConnection.dbName = selectedConnectionInfo[0].name;
      selectedConnection.connectionId = selectedConnectionInfo[0].id;
    } else if (status === completed) {
      selectedConnection.dbName = selectedConnectionInfo[0].name;
      selectedConnection.connectionId = selectedConnectionInfo[0].id;
    } else if (status == initialize) {
      selectedConnection.dbName = selectedConnectionInfo[0].name;
      selectedConnection.connectionId = selectedConnectionInfo[0].id;
    }
    return selectedConnection;
  }
  getmessage(status) {
    let message = this.message;
    if (status && status.toLowerCase() === inProgress.toLowerCase()) {
      message = infoConfigMessage;
    } else if (status === completed) {
      message = sucessConfigMessage;
    } else if (status == initialize) {
      return (message = '');
    } else if (status == deleted) {
      return (message = '');
    }
    return message;
  }

  getIsProgressBar(status) {
    let isProressBar = this.isProressBar;
    if (status && status.toLowerCase() === inProgress.toLowerCase()) {
      isProressBar = true;
    } else if (status === completed) {
      isProressBar = false;
    } else if (status == initialize) {
      isProressBar = false;
    } else if (status == error) {
      isProressBar = false;
    } else if (status == deleted) {
      isProressBar = false;
    }
    return isProressBar;
  }

  getConfigureIsDisable(status) {
    let isConfigureDisable = this.isConfigureDisable;
    if (status && status.toLowerCase() === inProgress.toLowerCase()) {
      isConfigureDisable = true;
    } else if (status === completed) {
      isConfigureDisable = true;
    } else if (status == error) {
      isConfigureDisable = false;
    } else if (status == deleted) {
      isConfigureDisable = false;
    }
    return isConfigureDisable;
  }
  initializeDefaultValues(connectionList) {
    return {
      connectionList: connectionList,
      isConfigureDisable: false,
      schemaKey: null,
      selectedConnection: {
        dbName: '',
        connectionId: ''
      },
      message: '',
      isProressBar: false,
      schemaStatus: null
    };
  }

  updateState(connectionList, schemaKey, isConfigureDisable, selectedConnection, message, isProressBar, schemaStatus) {
    return {
      connectionList: connectionList,
      isConfigureDisable: isConfigureDisable,
      schemaKey: schemaKey,
      selectedConnection: selectedConnection,
      message: message,
      isProressBar: isProressBar,
      schemaStatus: schemaStatus
    };
  }

  onClickConfigureNLQ = () => {
    let self = this;
    this.props.store
      .saveConfigureforNLQ(this.state.selectedConnection.connectionId)
      .then(data => {
        var obj = {
          schemaKey: data.schemaKey,
          schemaStatus: data.status,
          isProressBar: data.success,
          isConfigureDisable: data.success,
          message: data.success ? infoConfigMessage : data.message
        };
        //localStorage.setItem(localStoarageKey, JSON.stringify(obj));
        this.setState(obj);
      })
      .catch(function(error) {
        console.log(error);
        self.setState({
          isProressBar: false,
          isConfigureDisable: false,
          schemaStatus: 'Error',
          message: errorMessage
        });
        self.activeNLQInfo = null;
      });
  };
  onClickResetNLQ = () => {
    let self = this;
    var props = this.props;
    var loader = props.loader;
    props
    .confirmFn('Confirmation', {
      description: resetConfirmMessage
    })
    .then(loader.startLoading.bind(loader))
        .then(function() {
          return props.store
          .ResetNLQ()
          .then(data => {
            var obj = {
              message: data.messages[0].messages[0]
            };
            if(data.success)
            {
              self.state.schemaKey=null;
              self.state.selectedConnection.dbName='';
              self.state.selectedConnection.connectionId='';
            }
            self.setState(obj);
          })
          .catch(function(error) {
            console.log(error);
            self.setState({
              message: errorMessage
            });
            self.activeNLQInfo = null;
          });
        })
        .finally(loader.endLoading.bind(loader));
  };

  onConnectorTypeChange = selectedConnector => {
    const selectedValue = {
      dbName: selectedConnector.label,
      connectionId: selectedConnector.value
    };
    this.updateonConnectorTypeChange(selectedValue, this);
  };

  updateonConnectorTypeChange(selectedConnector, self) {
    if (selectedConnector.connectionId == '') {
      this.setState({ isConfigureDisable: true, message: this.message });
      return;
    }
    var activeNlqInfo =self.state.connectionList.filter(item => item.id==selectedConnector.connectionId);
    
    if (self.activeNLQInfo == null) {
      let updateStateValue = self.updateState(
        self.state.connectionList,
        self.state.schemaKey,
        self.getConfigureIsDisable(initialize),
        self.getSelectedConnection(self.state.connectionList, initialize, selectedConnector.connectionId),
        self.getmessage(initialize),
        self.getIsProgressBar(initialize),
        initialize
      );
      self.setState(updateStateValue);
      if(!activeNlqInfo[0].visible){
        self.setState({message:connectionDisableMsg,isProressBar:false,isConfigureDisable:true});
        }
    } else {
      let status = initialize;
      if (!isEmpty(self.activeNLQInfo.selectedConnection)) {
        if (
          self.activeNLQInfo.selectedConnection.connectionId.toLowerCase() ===
          selectedConnector.connectionId.toLowerCase()
        ) {
          status = self.activeNLQInfo.schemaStatus;
        }
      }

      let updateStateValue = self.updateState(
        self.state.connectionList,
        self.state.schemaKey,
        self.getConfigureIsDisable(status),
        self.getSelectedConnection(self.state.connectionList, status, selectedConnector.connectionId),
        self.getmessage(status),
        self.getIsProgressBar(status),
        status
      );
      self.setState(updateStateValue);
      if(!activeNlqInfo[0].visible){
        if(self.state.schemaKey==selectedConnector.connectionId)
        {
        self.setState({message:activeNLQDisableMsg,isProressBar:false,isConfigureDisable:true});
        }
        else{
          self.setState({message:connectionDisableMsg,isProressBar:false,isConfigureDisable:true});
        }
      }
    }
  }

  render() {
    let localization = this.props.localization;

    return (
      <div>
        <GridLayout.Row>
          <GridLayout.Col cols={3}>
            <label className={clazzName}>{localization.getText('NLQ_CONFIGURATION_SETTINGS_DATACONNECTORS')}</label>
          </GridLayout.Col>
          <GridLayout.Col cols={9}>
            <DropDown
              disabled={this.state.isProressBar}
              labelField='name'
              valueField='id'
              blankOption
              blankOptionText={'Select Active NLQ'}
              options={this.state.connectionList}
              value={this.state.selectedConnection.connectionId}
              onChange={this.onConnectorTypeChange}
              ref='dbConnectionType'
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols={2}>
            <Button
              onClick={this.onClickConfigureNLQ}
              disabled={this.state.isConfigureDisable}
              className='btn btn-default confi_cusBtn'
              defaultClasses={true}
              label={'Configure NLQ'}
            />
            &nbsp;
          </GridLayout.Col>
          <GridLayout.Col cols={2}>
            <Button
              onClick={this.onClickResetNLQ}
              disabled={this.state.isProressBar || this.state.schemaKey==null}
              className='btn btn-default confi_cusBtn'
              defaultClasses={true}
              label={'Reset NLQ'}
            />
          </GridLayout.Col>
          <GridLayout.Col cols={7}>
            <div className='not_txt'>
              <div className='lds-spinner' style={{ visibility: this.state.isProressBar ? 'visible' : 'hidden' }}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>

              <div className='msg_txt'>
                <p
                  style={{
                    color: !this.state.isProressBar && this.state.schemaStatus == 'Error' ? '#FF0000' : '#60c720'
                  }}
                  className='txtmessage'
                >
                  {this.state.message}
                </p>
              </div>
            </div>
          </GridLayout.Col>
        </GridLayout.Row>
      </div>
    );
  }
}
export default NLQSettingConfiguration;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/NlqConfiguration/Izenda.NLQSettingConfiguration.js